<!-- 柱状图 -->
<style lang="stylus" scoped>
.bar-wrap {
  width: 100%;
  height: 290px;
  padding: 18px 0;
  overflow: hidden;

  .swiper-wrap {
    height: 256px;
  }

  .active-item {
    width: 100%;
    height: 32px;
    margin-bottom: 19px;
    line-height: 32px;
  }

  .active-item i, .active-item .item-name-num, .active-item span, .active-item em {
    float: left;
    height: 100%;
    color: #fff;
    font-size: 20px;
    font-style: normal;
    box-sizing: border-box;
  }

  .active-item .item-rank {
    width: 35px;
    color: #fff;
    text-align: center;
  }

  .active-item .item-name-num {
    width: 400px;
    border-bottom: 1px solid rgba(0, 108, 243, 0.65);
  }

  .active-item .item-name-num .item-name {
    padding-left: 30px;
    border-right: 1px solid rgba(0, 108, 243, 0.65);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background: linear-gradient(to right, #040B58, #0A30B1);
  }

  .active-item .item-name-num .item-num {
    float: right;
    font-size: 16px;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="bar-wrap">
      <swiper :options="swiperOption" class="swiper-wrap" ref="mySwiper" v-if="listData.length!=0">
        <swiper-slide class="active-item" v-for="(item,index) in listData" :key="index">
          <i class="item-rank" :style="changeColor(index)">{{index+1}}</i>
          <div class="item-name-num">
            <span class="item-name" :style="changeLength(index)">{{item.name}}</span>
            <em class="item-num">{{item.val}}</em>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </boxWrap>
</template>

<script>
import echarts from "echarts";
import boxWrap from "components/dashboard/common/boxWrap";
import "../../../../static/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      name: "各地区电商帮扶总额排行",
      listData: [
        { name: "田州镇", val: "5313309元" },
        { name: "坡洪镇", val: "4762707元" },
        { name: "那坡镇", val: "4349740元" },
        { name: "五村镇", val: "3386202元" },
        { name: "头塘镇", val: "3110901元" },
        { name: "洞靖镇", val: "2092287元" },
        { name: "百育镇", val: "2009696元" },
        { name: "那满镇", val: "1156264元" },
        { name: "玉凤镇", val: "853433元" },
        { name: "巴别乡", val: "495541元" }
      ],
      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"],
      lengthList: [300, 285, 255, 230, 200, 180, 160, 150, 140, 130],
      swiperOption: {
        slidesPerView: "auto",
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 170,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    };
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  computed: {},
  methods: {
    changeColor(index) {
      if (index <= 3) {
        return `background:${this.colorList[index]}`;
      } else {
        return `background:${this.colorList[3]}`;
      }
    },
    changeLength(index) {
      return `width:${this.lengthList[index]}px`;
    }
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// index.vue?5d40b504